import React from 'react'
import ReviewFromGroup from '../../components/public/ReviewFromGroup'
import { useParams } from 'react-router-dom';

export default function VendorsReviewGroup() {
  return (
    <>
    <ReviewFromGroup />
  </>
  )
}
